import { render } from "./BaseSelector.vue?vue&type=template&id=7e875a3a&scoped=true"
import script from "./BaseSelector.vue?vue&type=script&lang=js"
export * from "./BaseSelector.vue?vue&type=script&lang=js"

import "./BaseSelector.vue?vue&type=style&index=0&id=7e875a3a&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e875a3a"]])

export default __exports__